import { TableCell as FBTableCell } from "flowbite-react";

const TableCell = (props) => {
  return <FBTableCell {...props}>{props.children}</FBTableCell>;
};

export default TableCell;